
'use strict'
import navbarController from "./navbar.controller";
import adultweightController from "./adultweight.controller";
import breedController from "./breed.controller";
import breedListController from "./breedlist.controller";
import breedsAnalyzedController from "./breedsanalyzed.controller";
import breedsCertificateController from "./breedscertificate.controller";

import breedTestsController from './breedtests.controller';

//health
import carrierController from "./carrier.controller";
import noCallController from "./nocall.controller";
import allclearController from "./allclear.controller";
import atriskController from "./atrisk.controller";

import eicController from "./eic.controller";
import exceptionLetterController from "./exceptionletter.controller";
import faqController from "./faq.controller";
import glossaryController from "./glossary.controller";
import healthController from "./health.controller";
import homePageController from "./homepage.controller";
import inheritanceController from "./inheritance.controller";
import learnmoreController from "./learnmore.controller";
import mixedcomponentController from "./mixedcomponent.controller";
import multidrugsensitivityController from "./multidrugsensitivity.controller";
import notesController from "./notes.controller";
import pbddletterController from "./pbddletter.controller";
import percentageController from "./percentage.controller";
import printController from "./print.controller";
import printBreedController from "./printbreed.controller";
import technologyController from "./technology.controller";
import thescienceController from "./thescience.controller";
import traitsController from "./traits.controller";
import ancestryController from './ancestry.controller';
import learnmoreTraitsController from './learnmoretraits.controller';

import upgradeModalController from './upgrademodal.controller';
//other controllers

let controllers = [
  navbarController
  ,adultweightController
  ,allclearController
  ,atriskController
  ,breedController
  ,breedListController
  ,breedsAnalyzedController
  ,breedsCertificateController
  ,breedTestsController
  ,carrierController
  ,eicController
  ,exceptionLetterController
  ,faqController
  ,glossaryController
  ,healthController
  ,homePageController
  ,inheritanceController
  ,learnmoreController
  ,mixedcomponentController
  ,multidrugsensitivityController
  ,notesController
  ,pbddletterController
  ,percentageController
  ,printController
  ,printBreedController
  ,technologyController
  ,thescienceController
  ,traitsController
  ,ancestryController
  ,learnmoreTraitsController
  ,noCallController
  ,upgradeModalController
];

export default angular.module("mars.vet.dnareports.controllers",controllers);



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/index.js